import { SectionCard } from "./SectionCard";
import { fmtUSD, fmtCliente, buildVendedorAbbrev } from "@/lib/api";

export default function Cobranzas({ data }) {
  if (!data) return null;
  const vmap = buildVendedorAbbrev((data.items || []).map((r) => r.vendedor));
  return (
    <SectionCard
      id="cobranzas"
      testid="section-cobranzas"
      num="1"
      title="Cobranzas del Periodo"
      description="Detalle de cobros por cliente, con acumulado histórico del cliente en el mes."
    >
      <div className="overflow-x-auto rounded-lg border border-slate-100 pb-20">
        <table className="w-full table-fixed text-sm">
          <colgroup>
            <col />
            <col style={{ width: "130px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "120px" }} />
          </colgroup>
          <thead>
            <tr className="bg-slate-50 text-slate-500 font-semibold">
              <th className="text-left px-3 py-3 sticky left-0 bg-slate-50 z-[3]">Cliente</th>
              <th className="text-left px-3 py-3">Vendedor</th>
              <th className="text-right px-3 py-3">Monto</th>
              <th className="text-right px-3 py-3">Cobro Acum. Cliente</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map((r, i) => (
              <tr key={i} className="border-t border-slate-100 hover:bg-emerald-50/40">
                <td className="px-3 font-medium text-slate-800 sticky left-0 bg-white z-[1]">
                  <span className="block truncate" title={r.cliente}>{fmtCliente(r.cliente)}</span>
                </td>
                <td className="px-3 text-slate-600">
                  <span className="block truncate" title={r.vendedor}>{vmap[r.vendedor] || r.vendedor}</span>
                </td>
                <td className="px-3 tm-num text-slate-800">{fmtUSD(r.monto_usd)}</td>
                <td className="px-3 tm-num font-semibold text-emerald-700">{fmtUSD(r.cobro_acumulado_cliente)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4 grid sm:grid-cols-2 gap-3">
        <div className="rounded-lg bg-emerald-50 border border-emerald-100 px-4 py-3 flex items-center justify-between">
          <span className="text-xs font-semibold uppercase tracking-wide text-emerald-700">
            Total Cobrado del Mes
          </span>
          <span data-testid="total-cobrado-mes" className="tm-num font-bold text-emerald-800">
            {fmtUSD(data.total_cobrado_mes)}
          </span>
        </div>
        <div className="rounded-lg bg-emerald-900 px-4 py-3 flex items-center justify-between">
          <span className="text-xs font-semibold uppercase tracking-wide text-emerald-200">
            Total Acumulado del Año · {data.vendedor}
          </span>
          <span data-testid="total-acumulado-anio" className="tm-num font-bold text-white">
            {fmtUSD(data.total_acumulado_anio)}
          </span>
        </div>
      </div>
    </SectionCard>
  );
}
